import React, { forwardRef } from "react";
import Alert, { AlertProps } from "@mui/material/Alert";

export interface OcSnackbarAlertProps extends AlertProps {
  /**
   * The severity of the alert. If omitted, the component renders null.
   */
  severity?: AlertProps["severity"];
}

export const OcSnackbarAlert = forwardRef<HTMLDivElement, OcSnackbarAlertProps>(
  function OcSnackbarAlert({ severity, ...props }, ref) {
    if (!severity) {
      return null;
    }

    const backgroundColor: string =
      {
        error: "#CC0033",
        success: "#2FA84F",
        warning: "#F3AA18",
        info: "#1976D2",
      }[severity] ?? "#2FA84F";

    return (
      <Alert
        elevation={6}
        variant="filled"
        ref={ref}
        severity={severity}
        {...props}
        sx={{
          backgroundColor,
          color: "#fff",
          fontSize: "16px",
          letterSpacing: "0.25px",
          minWidth: "auto",
          ...props.sx,
        }}
      />
    );
  },
);

OcSnackbarAlert.displayName = "OcSnackbarAlert";

export default OcSnackbarAlert;
